<template>
  <div id="body-root" class="tile is-ancestor">
    <div class="tile is-vertical">
      <div class="tile">
        <div class="tile is-parent">
          <article class="tile is-child notification primary-dark image-container">
            <figure class="image is-2by3">
              <img id="headshot" src="../assets/AndrewDiana.jpg">
            </figure>
          </article>
        </div>
        <div class="tile is-parent is-vertical">
          <article class="tile is-child notification primary-light">
            <p class="title">About Me</p>
            <p class="content is-medium">
              I'm currently a Senior at The Rochester Institute of Technology pursuing an undergraduate degree in Web and Mobile Computing.
              It is here that I have discovered my passion for problem solving and creating modern web apps.
              I'm available for a Summer Co-op starting in late May 2019.
            </p>
            <p
              class="content is-medium"
            >While at RIT, I have managed to maintain a 3.65 GPA and make Dean's List every semester.</p>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child notification primary">
            <p class="subtitle is-4">Languages</p>
            <div class="columns">
              <div class="column">
                <div>JavaScript
                  <span>
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  </span>
                </div>
                <div>PHP
                  <span>
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  </span>
                </div>
                <div>C#
                  <span>
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  </span>
                </div>
                <div>Java
                  <span>
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  </span>
                </div>
                <div>Swift
                  <span>
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  </span>
                </div>
              </div>
            </div>
            <p class="subtitle is-4">Frameworks</p>
            <div class="columns">
              <div class="column">
                <div>Vue
                  <span>
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  </span>
                </div>
                <div>React
                  <span>
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  </span>
                </div>
                <div>Angular
                  <span>
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  </span>
                </div>
                <div>Laravel
                  <span>
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  </span>
                </div>
                
              </div>
            </div>
            <p class="subtitle is-4">Database</p>
            <div class="columns">
              <div class="column">
                <div>MySQL
                  <span>
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  </span>
                </div>
                <div>
                  MongoDB
                  <span>
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  </span>
                </div>
              </div>
            </div>
            <p class="subtitle is-4">Other Skills</p>
            <div class="columns">
              <div class="column">
                <div>Project Management
                  <span>
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  </span>
                </div>
                
                <div>Linux 
                  <span>
                    <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                    <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                    <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  </span>
                </div>

                <div>Scrum Methodologies
                  <span>
                    <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                    <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                    <img height="15" width="15" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/macys.svg" />
                  </span>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child notification secondary">
          <p class="title">Projects</p>
          <p class="subtitle">What I've been developing lately</p>
          <div class="tile is-ancestor">
            <div class="tile is-parent">
              <div class="tile is-child card">
                <div class="card">
                  <header class="card-header">
                    <p class="card-header-title">
                      Workflow Application
                    </p>
                  </header>
                  <div class="card-image">
                    <figure class="image">
                      <img
                        src="../assets/workflow.png"
                        alt="Placeholder image"
                      >
                    </figure>
                  </div>
                  <div class="card-content">
                    <div class="content">
                      <span class="has-text-weight-bold">Frameworks Used: Laravel, Vue.js</span>
                      <br>
                      <span class="has-text-weight-bold">Languages Used: PHP7, ES6, HTML5, CSS3</span>
                      <br><br>
                      <span class="has-text-weight-semibold">I am currently a co-project manager on the development of this application.
                        My team is tasked with creating an online web application to replace the existing Workflow of the RIT's Venture Captial company- <a>Venture Creations</a>.
                        As well as coordinating the development of the application, I am also an acting Full-Stack Developer responsible for Vue.js webpage creation, Laravel API development, and hosting on an Apache Server.
                        The project is still underdevelopment and is expected to be completed by May of 2019.
                      </span>
                      <br>
                      <time datetime="2018-2-1">February 1st 2019 @ 3PM </time>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tile is-parent">
              <div class="tile is-child card">
                <div class="card">
                  <header class="card-header">
                    <p class="card-header-title">
                      Multiplayer Snake Game
                    </p>
                  </header>
                  <div class="card-image">
                    <figure class="image">
                      <img
                        src="../assets/snake.png"
                        alt="Placeholder image"
                      >
                    </figure>
                  </div>
                  <div class="card-content">
                    <div class="content">
                      <span class="has-text-weight-bold">Environment Used: Node</span>
                      <br>
                      <span class="has-text-weight-bold">Frameworks Used: Vue.js</span>
                      <br>
                      <span class="has-text-weight-bold">Languages Used: ES6, HTML5, CSS3</span>
                      <br><br>
                      <span class="has-text-weight-semibold">For this project, I recreated the popular game Snake but with a twist- multiple players can control the snake.
                        I chose to use Vue.js for the frontend of the application with a Node backend and hosted it on Heroku.
                        This application taught me the challenges of using a SVG frontend game board, Node.js to handle the logic, and the library Socket.io to handle the user connections.
                        Some interesting aspects of this project include the usage of: Vue-router, VueX store, Express, Socket.io, and the mainipulation of an SVG Board.
                        This project was very fun to develop and even more fun to play with friends online. Sign up and give it a try <a target="_blank" href="https://safe-dusk-69192.herokuapp.com/?#/">Here</a>
                      </span>
                      
                      <br>
                      <time datetime="2018-12-7">December 7th 2018 @ 5PM</time>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tile is-parent no-right-padding">
              <div class="tile is-child card">
                <div class="card">
                  <header class="card-header">
                    <p class="card-header-title">
                      Should I Go Out Tonight?
                    </p>
                  </header>
                  <div class="card-image">
                    <figure class="image">
                      <img
                        src="../assets/partymachine.png"
                        alt="Placeholder image"
                      >
                    </figure>
                  </div>
                  <div class="card-content">
                    <div class="content">
                      <span class="has-text-weight-bold">Environment Used: Node</span>
                      <br>
                      <span class="has-text-weight-bold">Languages Used: ES6</span>
                      <br><br>
                      <span class="has-text-weight-semibold">This project was developed for Facebook's Messenger Bot Platform.
                        Using a Node server hosted on Heroku, I was able to create a bot that would roll the dice if a user should have a night on the town or stay in and catch up on some Netflix.
                        If the result was that they should go out- their location is requested to query Google's Places API. A challenge of this project was that all of the information that I needed for the results
                        was not available in one request which introduced me into Asynchronous Promise Chaining with ES6 syntax. This problem was one that I was able to overcome and publish onto the Messenger Platform
                        for all users to use. Give it a try <a target="_blank" href="https://m.me/partymachinebot">Here</a>.
                      </span>
                      <br>
                      <time datetime="2018-2-18">February 2nd 2018 @ 12PM</time>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
      <div class="tile is-parent is-vertical">
          <article class="tile is-child notification primary-light">
            <p class="title">Want More Information?</p>
            <p
              class="content"
            >Here's my <a target="_blank" href="https://docs.google.com/document/d/1xzBNi6D4C0BmQ-T14j67O4RXW9n-JhbPMnU6DsYPtAQ/edit?usp=sharing" class="button primary-dark">Resume</a>
            Or <a class="button primary-dark" href="mailto:axd7832@rit.edu?Subject=Hello" target="_top">Email Me</a>
            </p> 
          </article>
        </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Body",
  data() {
    return {};
  }
};
</script>

<style scoped>
#body-root {
  margin: 10px;
}
#headshot {
  object-fit: contain;
}
.no-right-padding {
  padding-right: 0px !important;
}
.card {
  box-shadow: none !important;
}
.image-container {
  padding-right: 25px;
}

@media only screen and (max-width: 800px) {
    .tile .is-parent {
      padding-right: 10px;
    }
  }
</style>
